module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Leave-Credit/leave-credit-authorization/leave-credit-auth/leave-credit-auth.component.css
// module id = ./src/app/hrms/Leave-Credit/leave-credit-authorization/leave-credit-auth/leave-credit-auth.component.css
// module chunks = main